import { BadgeCommonProps } from "@certn/cascadia/components/badge/types";

import { _Badge } from "./_Badge";

export function SuccessBadge(props: BadgeCommonProps) {
  const {
    type = "bold",
    testID = "danger-badge",
    size = "large",
    ...rest
  } = props;

  if (type === "bold")
    return (
      <_Badge
        fill="background-accent-green-strong"
        color="text-accent-green-weak"
        testID={testID}
        size={size}
        {...rest}
      />
    );

  return (
    <_Badge
      fill="background-accent-green-weak"
      color="text-accent-green-strong"
      testID={testID}
      size={size}
      {...rest}
    />
  );
}
